<template>
  <div class="wrapper">
    <div class="tilte-text"> 资金明细 </div>
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <span class="search-label">提现金额</span>
        <Input v-model="searchForm.withdrawMix" placeholder="提现金额" style="width: 150px;" />
        <span class="search-rang-label">至</span>
        <Input v-model="searchForm.withdrawMax" placeholder="提现金额" style="width: 150px;" />
      </template>
      <template>
        <span  class="search-label">选择时间</span>
        <DatePicker type="date" placeholder="提现时间" v-model="searchForm.createStartTime" style="width: 150px;"></DatePicker>
        <span class="search-rang-label">至</span>
        <DatePicker type="date" placeholder="提现时间" v-model="searchForm.createEndTime"></DatePicker>
      </template>
<!--      <template>-->
<!--        <span class="search-label">选择时间</span>-->
<!--        <DatePicker type="date" placeholder="处理提现时间" v-model="searchForm.doneStartTime" style="width: 150px;"></DatePicker>-->
<!--        <span style="padding: 0 5px;">至</span>-->
<!--        <DatePicker type="date" placeholder="处理提现时间" v-model="searchForm.doneEndTime"></DatePicker>-->
<!--      </template>-->
      <template>
        <Button type="text" class="search-btn margin-left-30" @click="handleFilter">查询</Button>
      </template>
    </div>
    <div class="table-wrapper">
      <Table border
             :columns="columns"
             :data="list"
             :loading="listLoading"
             >
        <template slot-scope="{ row }" slot="state">
          <span :class="row.state==20 ? 'color-D63036': 'color-666666'">{{getStateText(row.state)}}<span v-if="row.state==20 && row.remark">（{{row.remark}}）</span></span>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total"
              :current="searchForm.pageNo"
              show-sizer
              show-elevator
              show-total
              @on-change="changePage"
              @on-page-size-change="changePagesize"
              ></Page>
      </div>
    </div>
  </div>
</template>
<script>
  import { getPlatformUuidKfc } from '@/utils/auth'
  import { Icon, Table, Page, Button, Option, Input, DatePicker } from 'view-design'
  import { getDate } from '@/utils/date'
  import withdraw from '@/javaApi/kfc/withdraw.js'
  const withdrawModel = new withdraw()
  export default {
    name: 'Member',
    components: {
      Icon,
      Table,
      Page,
      Button,
      Option,
      Input,
      DatePicker
    },
    data: function () {
      return {
        columns: [
          {
            title: '序号',
            key: 'sequence'
          },
          {
            title: '真实姓名',
            key: 'name',
          },
          {
            title: '支付宝账号',
            key: 'alipay'
          },
          {
            title: '提现金额',
            key: 'withdraw',
          },
          // {
          //   title: '实际打款金额',
          //   key: 'actualWithdrawal'
          // },
          {
            title: '提现时间',
            key: 'createTime',
          },
          // {
          //   title: '打款时间',
          //   key: 'doneTimeStr',
          // },
          {
            title: '提现状态',
            key: 'state',
            slot:'state'
          }
        ],
        listLoading: false,
        list:[
        ],
        total:0,
        platformUuid:getPlatformUuidKfc(),
        searchForm: {
          pageNo: 1,
          pageSize: 10,
          id: undefined,
          withdrawMix:undefined,
          withdrawMax:undefined,
          createStartTime: undefined,
          createEndTime: undefined,
          // doneEndTime:undefined,
          // doneStartTime:undefined
        }
      }
    },
    created() {
      this.getList(true)
    },
    methods: {
      getList(first = false){
        let that = this
        this.listLoading = true
        if(first) this.searchForm.pageNo = 1
        let searchForm = Object.assign({}, this.searchForm)
        searchForm.createStartTime = getDate(searchForm.createStartTime)
        if(searchForm.createStartTime){
          searchForm.createStartTime = searchForm.createStartTime+' 00:00:00'
        }else{
          delete  searchForm.createStartTime
        }

        searchForm.createEndTime = getDate(searchForm.createEndTime)
        if(searchForm.createEndTime){
          searchForm.createEndTime = searchForm.createEndTime+' 23:59:59'
        }else{
          delete  searchForm.createEndTime
        }

        // searchForm.doneStartTime = getDate(searchForm.doneStartTime)
        // if(searchForm.doneStartTime){
        //   searchForm.doneStartTime = searchForm.doneStartTime+' 00:00:00'
        // }else{
        //   delete  searchForm.doneStartTime
        // }
        // searchForm.doneEndTime = getDate(searchForm.doneEndTime)
        // if(searchForm.doneEndTime){
        //   searchForm.doneEndTime = searchForm.doneEndTime+' 23:59:59'
        // }else{
        //   delete  searchForm.doneEndTime
        // }
        if(!searchForm.withdrawMix){
          delete searchForm.withdrawMix
        }
        if(!searchForm.withdrawMax){
          delete searchForm.withdrawMax
        }
        searchForm.platformUuid =  this.platformUuid
        searchForm = this.formateInit(searchForm)
        withdrawModel.getWithdrawList(searchForm).then(response=>{
          that.listLoading = false
          let res = response.data
          if(res.code == 200){
              if(res.data){
                this.list = res.data.list?res.data.list:[]
                this.list = this.formateData(this.list)
                this.total =  res.data.total?res.data.total:0
              }
          }else{
            let message = res.message?res.message:'系统异常,请稍后再试！'
            that.$Message.error(message)
          }
        }).catch(error=>{
          console.log(error)
          that.listLoading = false
            if(error != 'token invalid'){
              this.$Message.error('系统异常请稍后再试！')
            }
        })
      },
      formateData(data){
        if(!data){
          return []
        }
        if(!data.length){
          return []
        }
        let i = 0;
        let pageNo = this.searchForm.pageNo
        let pageSize = this.searchForm.pageSize
        for(i=0;i<data.length;i++){
          data[i].sequence = (i+1)+(pageNo - 1)*pageSize
        }
        return  data
      },
      getStateText(state){
        // 提现状态：10 提现成功，20 提现失败
        let text = ''
        switch (parseInt(state)){
          case 10:
            text = '提现成功'
          break;
          case 20:
            text = '提现失败'
          break;
        }
        return text
      },
      handleFilter(){
        this.getList(true)
      },
      changePage(value){
        this.searchForm.pageNo = value
        this.getList()
      },
      changePagesize(value){
        this.searchForm.pageSize = value;
        //如果处于第一页改变数量，则会触发changePage
        if(this.searchForm.pageNo == 1){
          this.getList()
        }
      },
      formateInit(formData){
        let objCopy = {};
        for(let key in formData){
          if(formData[key]){
            objCopy[key] = formData[key];
          }
        }
        return objCopy;
      },
    }
  }
</script>
<style scoped>
  .wrapper {
    width: 100%;
    font-size: 12px;
  }
  .wrapper .tilte-text {
    font-size: 18px;
    color: #222222;
    text-align: left;
    font-weight: bold;
  }
  .wrapper .table-wrapper {
    margin-top: 30px;
  }
  .search-wrap .ivu-icon-ios-arrow-down:before{
    color: #232323;
    content: "\F33D";
  }
  .ivu-date-picker-rel {
    margin: 11px 0;
  }
  .ivu-table{
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 2px;
  }
  .table-wrapper .ivu-table-header th {
    background-color: #FCFAF8 !important;
  }
  .table-wrapper .ivu-table-header th .ivu-table-cell{
    color: #222222 !important;
  }
  .table-wrapper .ivu-table-wrapper-with-border{
    border: none;
  }
  .table-wrapper .ivu-table-wrapper-with-border{
    border-radius: 0px;
    border-color: #FFFFFF !important;
  }
  .color-D63036{
    color: #D63036;
  }
  .color-666666{
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/withdraw/Index.vue